// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@ces/XDL/types";

export default {
    primary: {
        main: "#1D4486",
        contrast: "#FFFFFF",
    },
    secondary: {
        main: "#F58220",
        contrast: "#FFFFFF",
    },
    common: {
        background: "#FFFFFF",
        backgroundContrast: "#363636",
        accent: "#F8F9FA",
        accentContrast: "#363636",
        border: "#999999",
        disabled: "#EEEEEE",
        ui1: "#FFFFFF",
        ui2: "#EEEEEE",
        ui3: "#CCCCCC",
        ui4: "#999999",
        ui5: "#666666",
        ui6: "#333333",
        ui7: "#2D68B2",
        ui8: "#8FB1DC",
        ui9: "#FFC18C",
        ui10: "#C05D09",
        ui11: "#E7E7E8",
        ui12: "#0F154E",
        white: "#FFFFFF",
        black: "#000000",
    },
    text: {
        main: "#000000",
        disabled: "#475353",
        accent: "#2D3435",
        link: "#2D68B2",
        visited: "#1D4486",
    },
    success: {
        main: "#00A65A",
        contrast: "#FFFFFF",
        light: "#D9F2E7",
    },
    danger: {
        main: "#E4104E",
        contrast: "#FFFFFF",
        light: "#FBDBE5",
    },
    warning: {
        main: "#DAA91C",
        contrast: "#FFFFFF",
        light: "#FDF9DE",
    },
    info: {
        main: "#53ACDB",
        contrast: "#FFFFFF",
        light: "#DDEEF8",
    },
} as xBaseTheme["colors"];
